// extracted by mini-css-extract-plugin
export default {"GlobalErrorBoundary":"GlobalErrorBoundary_GlobalErrorBoundary__Ua7hS","Logo":"GlobalErrorBoundary_Logo__JKQeN","Buttons":"GlobalErrorBoundary_Buttons__J2hej"};